import React from "react"
import NoContent from "components/elements/NoContent"
import DocsLink from "components/DocsLink"
import { DESKTOP_PDF_BADGE_PRINTING_ARTICLE_URL } from "utilities/externalLinks"

const NoBadges = () => (
  <NoContent
    title="Badge Templates"
    icon="badges"
    descriptionItems={[
      "No badge templates found. Create one to start generating and printing guest badges.",
    ]}
    footer={(
      <DocsLink url={DESKTOP_PDF_BADGE_PRINTING_ARTICLE_URL} fontWeight="semibold">
        Desktop & PDF Badge Printing Guide
      </DocsLink>
    )}
  />
)

export default NoBadges
